import { createFileRoute, Outlet } from '@tanstack/react-router'

/* ───── Route Definition ───── */

export const Route = createFileRoute('/_authenticated/admin/monitoring')({
  component: AdminMonitoringLayout,
})

/* ───── Layout Component ───── */

function AdminMonitoringLayout() {
  return <Outlet />
}
